import { fetch } from '@atlassian/eoc-fetch';
export const fetchKeys = async accountId => {
  return fetch('/api-keys/web?accountId=' + accountId);
};
export const deleteApiKey = async (key, accountId) => {
  return fetch(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
    method: 'DELETE'
  });
};